export const CANCEL_EMAIL_UPDATE = 'CANCEL_EMAIL_UPDATE';
export const RESEND_ACTIVATION_EMAIL = 'RESEND_ACTIVATION_EMAIL';

export type CancelEmailUpdateAction = {
    type: typeof CANCEL_EMAIL_UPDATE;
    payload: boolean;
};

export type ResendActivationEmailAction = {
    type: typeof RESEND_ACTIVATION_EMAIL;
    payload: boolean;
};

export type EmailActionTypes = CancelEmailUpdateAction | ResendActivationEmailAction;
